import { DomainProductLine } from 'types/domainServiceV2';
import { SupportedUserRoles } from '@insurancemenu/imenu-components-lib/dist/types';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { Cart } from 'types/cartServiceV2';
import { FetchPolicy } from '@apollo/client';
import { ProposalItemsStore } from 'store/ui-stores/proposal-v2/proposalItemsStore';
import { PortfolioItemsByProductLine } from './types';

export default abstract class IProposalPageStore {
  // TO_DO: REMOVE
  abstract initialStore: ProposalItemsStore;
  abstract userRoles: SupportedUserRoles[];
  abstract cartId: string;

  abstract getDomainProductLine(productLineId: ProductLineId): DomainProductLine | undefined;
  abstract getPortfolioByProductLine(productLineId: ProductLineId): PortfolioItemsByProductLine;
  abstract updateCustomPortfolioAndCart(cart: Cart, portfolioId: string, checkRates?: boolean): Promise<void>;
  abstract updateCartItem(portfolioId: string, policy: FetchPolicy): Promise<void>;
}
